import React, { useContext } from 'react'
import { SideberContext } from '../context/SidebarContext'
import { ApiContext } from '../context/ApiContext';
import { useTranslation } from 'react-i18next';
import { getLanguage,setLanguage } from '../helper/LanguageHelper';

function Notification() {
  const { myNotification, setMyNotification, ourService, setOurService,language } = useContext(SideberContext)
  const { data } = useContext(ApiContext)
   const { t,i18n } = useTranslation();
  const lang = getLanguage() || 'fr';
  const LANGUAGES = [
  {code: "en", title: "English"},
  {code: "fr", title: "French"},
  {code: "ar", title: "Arabic"},
  // {code: "hi", title: "Hindi"},
  // {code: "ja", title: "Japanese"},
  // {code: "ko", title: "Korean"},
  // {code: "es", title: "Spanish"},
];
 const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
  }

  return (
    <>
      {data ? <div className={myNotification ? 'Notification-main-active' : "Notification-main-unactive"} onClick={() => setMyNotification(false)}>
        <div className={myNotification ? 'Notification-main-inner-active' : "Notification-main-inner-unactive"} onClick={(e) => e.stopPropagation()}>
          {ourService ? <p className='Notification-para Notification-our-service'>{data.our_service}</p> :language ? (
  <div className="language-wrapper">
    <label htmlFor="language-select" className="language-label">
    {t("Language.Title")}
    </label>
    <select
      id="language-select"
      onChange={(e) => {
        changeLanguage(e.target.value);
        setMyNotification(false);
      }}
      defaultValue={lang}
      className="Notification-our-language"
    >
      {LANGUAGES.map((lang) => (
        <option value={lang.code} key={lang.code}>
          {lang.title}
        </option>
      ))}
    </select>
  </div>
): <p className='Notification-para Notification-our-service'>{data.about_us}</p>}
        </div>
      </div> : <div>finding</div>}
    </>
  )
}

export default Notification